import {
    css, Theme,
} from '@emotion/react'

import { textFieldStyle } from 'shared/TextStepField/TextStepField.style'

const styles = (theme: Theme) => {
    return { root: css`
        ${textFieldStyle(theme)};
        flex: 1 1 288px;
        max-width: 480px;

        & .MuiInputBase-root {
            border-radius: ${theme.shape.borderRadius}px;
        }

        & .MuiInputBase-root:not(.Mui-focused) .MuiOutlinedInput-notchedOutline {
            border: 1px solid ${theme.palette.secondary[400]};
        }
    ` }
}

export default styles
